import { useRouterState } from '@tanstack/react-router'

import type { JellyIconName } from '@/components/icons'
import { JellyIcon } from '@/components/icons'

import { AppLink } from './AppLink'

export type TabItem = {
  label: string
  href: string
  icon: JellyIconName
}

export function TabBar({ tabs }: { tabs: TabItem[] }) {
  const pathname = useRouterState({ select: (state) => state.location.pathname })

  return (
    <nav
      aria-label="Hlavní navigace aplikace"
      className="grid shrink-0 auto-cols-fr grid-flow-col border-t border-ink/10 bg-white px-1 pt-1.5 pb-[max(env(safe-area-inset-bottom),0.5rem)]"
    >
      {tabs.map((tab) => {
        const active = pathname === tab.href || pathname.startsWith(`${tab.href}/`)
        return (
          <AppLink
            key={tab.href}
            href={tab.href}
            aria-current={active ? 'page' : undefined}
            className={`flex flex-col items-center gap-1 rounded-xl py-1 text-[10px] font-semibold transition-colors duration-150 ${
              active ? 'text-brand' : 'text-ink/45 hover:text-ink/70'
            }`}
          >
            {/* Active tab switches to the fill variant — the native pattern */}
            <JellyIcon name={tab.icon} variant={active ? 'fill' : 'line'} className="size-5.5" />
            {tab.label}
          </AppLink>
        )
      })}
    </nav>
  )
}
